export const getChildIds = (record) => {
  if (Array.isArray(record?.childIds) && record.childIds.length > 0) {
    return record.childIds;
  }
  if (record?.childId) {
    return [record.childId];
  }
  return [];
};
